import { render, staticRenderFns } from "./requestClaim.vue?vue&type=template&id=41a3404a&scoped=true"
import script from "./requestClaim.vue?vue&type=script&lang=js"
export * from "./requestClaim.vue?vue&type=script&lang=js"
import style0 from "./requestClaim.vue?vue&type=style&index=0&id=41a3404a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a3404a",
  null
  
)

export default component.exports